const TIMING_HISTORY_LIMIT = 60;

function nowMilliseconds() {
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    return performance.now();
  }
  return Date.now();
}

export function startRequestTiming(category, path) {
  return {
    category: String(category || "request"),
    path: String(path || "unknown"),
    startedAt: nowMilliseconds(),
  };
}

export function finishRequestTiming(timing, outcome = "ok") {
  if (!timing) return null;

  const durationMs = Math.max(0, nowMilliseconds() - timing.startedAt);
  const entry = {
    category: timing.category,
    path: timing.path,
    durationMs: Math.round(durationMs),
    outcome: String(outcome || "ok"),
    recordedAt: new Date().toISOString(),
  };

  if (process.env.NODE_ENV !== "test" && typeof window !== "undefined") {
    const history = Array.isArray(window.__ANINA_REQUEST_TIMINGS__)
      ? window.__ANINA_REQUEST_TIMINGS__
      : [];
    history.push(entry);
    if (history.length > TIMING_HISTORY_LIMIT) {
      history.splice(0, history.length - TIMING_HISTORY_LIMIT);
    }
    window.__ANINA_REQUEST_TIMINGS__ = history;

    if (typeof console !== "undefined" && typeof console.info === "function") {
      console.info(
        `[Anina timing] ${entry.category} ${entry.path} ${entry.durationMs}ms (${entry.outcome})`,
      );
    }
  }

  return entry;
}
